export const headerHeight = {
  desktop: 108,
  mobile: 64
};
